import Select from 'react-select'
import { customStyles } from '../../common/Select'
import { Box, Button, Flex, Tooltip, useDisclosure } from '@chakra-ui/react'
import { useMemo } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import { UnderlineError } from "../styled";
import { getMessageHandlerClass } from '../AddSessionFormContent'
import { YamlView } from '../YamlView'
import { FormLabel } from '../../common/FormLabel'
import { FiServer } from 'react-icons/fi'

export const BaseMessagesHandlerSelect = ({ form,
    control,
    field,
    errors,
    fixVersion,
    fixVersions,
    notify,
    isViewOpen,
    isClearable,
    openView,
    closeView
}) => {
    const object = useWatch({
        name: field.name,
        control
    })

    const messageHandlerClasses = field.messageHandlerClasses

    const optionsList = useMemo(() => {
        return messageHandlerClasses ? messageHandlerClasses.map((el) => ({ value: el, label: el })) : []
    }, [messageHandlerClasses])

    return (
        <Box width="674px">
            <FormLabel
                required={field.required}
                helperText={field.helperText}
                disabled={field.disabled}
            >
                {field.label}
            </FormLabel>
            <Flex width="100%" alignItems="flex-start">
                {!isViewOpen &&
                <div
                    style={{
                        cursor: field.disabled ? 'not-allowed' : 'initial'
                    }}
                >
                    <Tooltip
                        label={field.disabledTooltip}
                        isDisabled={!field.disabled}
                        shouldWrapChildren={field.disabled}
                    >
                        <Controller
                            control={control}
                            name={field.name}
                            rules={{ required: field.required }}
                            render={({ field: formField }) => {
                                const classNameValue = getMessageHandlerClass(formField.value)
                                return <Select
                                    isClearable={isClearable}
                                    isDisabled={field.disabled}
                                    inputRef={formField.ref}
                                    value={{ value: classNameValue, label: classNameValue }}
                                    styles={customStyles}
                                    width={'630px'}
                                    error={form.formState.errors[formField.name]}
                                    onChange={(option) => {
                                        if (option) {
                                            formField.onChange({ [`@${option.value}`]: {} })
                                        } else {
                                            formField.onChange(null)
                                        }
                                    }}
                                    options={optionsList}
                                />
                            }}
                        />
                    </Tooltip>
                </div>}
                {isViewOpen &&
                <YamlView
                    object={object}
                    notify={notify}
                    closeView={closeView}
                />}
                <Tooltip
                    openDelay={500}
                    label={`View ${isViewOpen ? 'form input' : 'YAML config'}`}
                >
                    <Button
                        tabIndex='-1'
                        variant='ghost'
                        fontFamily='mono'
                        marginLeft='6px'
                        onClick={isViewOpen ? closeView : openView}
                        aria-label='View YAML config'
                        iconSpacing={0}
                        rightIcon={isViewOpen ? <FiServer style={{ margin: 0 }}/> : undefined}
                    >{isViewOpen ? undefined : '{}'}</Button>
                    {/* } */}
                </Tooltip>
            </Flex>
            {!!errors[field.name] &&
                <UnderlineError>
                    {errors[field.name].type === 'required' ? 'Required' : errors[field.name].message}
                </UnderlineError>}
        </Box>
    )
}

const withDisclosure = (WrappedComponent) => 

    (props) => {
        const { isOpen: isViewOpen, onClose: closeView, onOpen: openView } = useDisclosure()

        return (
            <WrappedComponent
                {...props}
                isViewOpen={isViewOpen}
                closeView={closeView}
                openView={openView}
            />
        )
    }

export const MessagesHandlerSelect = withDisclosure(BaseMessagesHandlerSelect)